module.exports = __webpack_public_path__ + "static/media/PageNotFound.f35e7995.png";